import React, { useState } from 'react';
import IcalSyncManager from '../Host/IcalSyncManager';
import { CloseIcon } from '../../AssetComponents/Images';

/**
 * IcalModal - Standalone modal for iCal calendar synchronization
 * 
 * This modal provides a dedicated interface for hosts to manage
 * their property's calendar synchronization with external platforms
 * like Airbnb, Booking.com, and Vrbo.
 */
const IcalModal = ({ isOpen, onClose, propertyId, propertyName }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg max-w-4xl w-full max-h-[90vh] overflow-hidden shadow-2xl">
        {/* Modal Header */}
        <div className="flex items-center justify-between p-6 border-b border-gray-200">
          {/* <div>
         
            <p className="text-sm text-gray-600 mt-1">
              {propertyName ? `Manage calendar sync for ${propertyName}` : 'Manage calendar synchronization'}
            </p>
          </div> */}
          
        </div>

        {/* Modal Content */}
        <div className="p-6 overflow-y-auto max-h-[calc(90vh-120px)]">
          <IcalSyncManager propertyId={propertyId} />
        </div>

        {/* Modal Footer */}
        <div className="flex justify-end p-6 border-t border-gray-200 bg-gray-50">
          <button
            onClick={onClose}
            className="px-6 py-2 bg-gray-600 text-white rounded-lg hover:bg-gray-700 transition-colors"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default IcalModal;
